<template>
    <v-card>
        <slot>
            <v-card-title>
                {{ title }}
                <v-spacer></v-spacer>
                <v-text-field
                    v-model.lazy="search"
                    append-icon="mdi-magnify"
                    label="Cautare..."
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:item.payment_id="{ item }">
                <payment-transaction-source :item="item"></payment-transaction-source>
            </template>
            <template v-slot:item.account_id="{ item }">
                <payment-transaction-destination :item="item"></payment-transaction-destination>
            </template>
            <template v-slot:item.amount="{ item }">
                {{ item.amount | price }}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ new Date(item.created_at) | date }}
            </template>
            <template v-slot:item.created_by="{ item }">
                {{ item.payment.created_by.name }}<br/>
                {{ item.payment.updated_by.name }}
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import SmartTable from "Components/SmartTable";
    import PaymentTransactionSource from "Components/reports/Common/PaymentTransactionSource.vue";
    import PaymentTransactionDestination from "Components/reports/Common/PaymentTransactionDestination.vue";
    export default {
        extends: SmartTable,
        components: {
            PaymentTransactionSource,
            PaymentTransactionDestination
        },
        data: () => ({
            title: 'Lista tranzactii',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Platitor', value: 'payment_id' },
                { text: 'Suma', value: 'amount' },
                { text: 'Cont', value: 'account_id' },
                { text: 'Adaugat/Creat de', value: 'created_by', sortable: false },
                { text: 'Data', value: 'created_at' }
            ],
            options: {
                sortBy: ['id'],
                sortDesc: [true]
            },
            items: [],
            editedIndex: -1
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                let { data, meta } = await this.$db.PaymentTransaction
                    .include(
                        'payment.accountable',
                        'payment.subject',
                        'payment.payer',
                        'account',
                        'payment.createdBy',
                        'payment.updatedBy'
                    )
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                    .get()
                this.items = data
                this.meta = meta
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },
        },
    };
</script>
